import scraperApi from "api";
import { ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";


// BUG: This reads coupons from the backend DB, not from Chargebee directly.
// If a coupon is added/removed in Chargebee (e.g. by customer support), the DB
// won't reflect it until a reconcile-on-read mechanism is added to the backend.
// This causes the UI to show stale coupons and incorrect discount prices vs invoices.
export const loader: ActiveCouponsDataRouteType["route"]["loader"] = async ({ request }) => {
  return {
    activeCoupons: await scraperApi.billing.coupons.getActiveCoupons({ signal: request.signal })
  };
}
